module.exports = __webpack_public_path__ + "img/front.e2055767.png";